import script from "./GlobalError.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalError.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalError.vue?vue&type=style&index=0&id=9031c31a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9031c31a"]])

export default __exports__